import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import deTranslations from "./locales/de/translation.json";

// Die Software ist einsprachig Deutsch; i18next bleibt als Infrastruktur
// fuer die t()-Aufrufe und eine allfaellige spaetere Sprache.
i18n
  .use(initReactI18next)
  .init({
    resources: {
      de: {
        translation: deTranslations
      }
    },
    lng: "de",
    fallbackLng: "de",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
